import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import { SImageLazy } from '@strana-artw/ui-kit';
import { toRefs } from 'vue';
import { useScreenPlugin } from '@/plugins/vue-screen';
import { YM_HIDE_CONTENT } from '@/shared/constants';
import { PhoneOutput } from '@/shared/ui/outputs';
export default {
  name: 'ConsultationSection',
  components: {
    PhoneOutput: PhoneOutput,
    SImageLazy: SImageLazy
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    template: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    manager: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  setup: function setup() {
    var _toRefs = toRefs(useScreenPlugin()),
      isMobile = _toRefs.isMobile;
    return {
      YM_HIDE_CONTENT: YM_HIDE_CONTENT,
      isMobile: isMobile
    };
  },
  computed: {
    managerName: function managerName() {
      var _this$manager, _this$manager2;
      return "".concat((_this$manager = this.manager) === null || _this$manager === void 0 ? void 0 : _this$manager.lastname, " ").concat((_this$manager2 = this.manager) === null || _this$manager2 === void 0 ? void 0 : _this$manager2.name);
    },
    managerPhoto: function managerPhoto() {
      var _this$manager3;
      return (_this$manager3 = this.manager) === null || _this$manager3 === void 0 || (_this$manager3 = _this$manager3.photo) === null || _this$manager3 === void 0 ? void 0 : _this$manager3.aws;
    }
  },
  methods: {
    handleValueChange: function handleValueChange(val) {
      this.value = val;
    }
  }
};